import { Pipe, PipeTransform } from '@angular/core';
import * as i18nIsoCountries from 'i18n-iso-countries';

@Pipe({
  name: 'translatedCountry',
  standalone: false,
})
export class TranslatedCountryPipe implements PipeTransform {
  transform(countryCode: string, languageCode: string): string {
    return i18nIsoCountries.getName(countryCode, languageCode);
  }
}
